<template>
  <Modal class="help-modal" :title="$t('app.modals.help.title')" :isOpen="isOpen" @close="close()" :buttons="[]">
    <template #extra>
      <transition name="fade" mode="out-in">
        <component :is="tabs[state.currentTab]" @next="tabCallback" @close="close()" :data="state.data" />
      </transition>
    </template>
  </Modal>
</template>

<script setup>
import { reactive } from "vue";
import Modal from "@/components/global/Modal.vue";
import ProblemTab from "./tabs/ProblemTab.vue";
import SolutionTab from "./tabs/SolutionTab.vue";

const emits = defineEmits(["close"]);

const tabs = [ProblemTab, SolutionTab];

const state = reactive({
  currentTab: 0,
  data: null,
});

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

function tabCallback(data) {
  state.currentTab++;
  state.data = data;
}

function close() {
  state.currentTab = 0;
  emits("close");
}
</script>
